const PrismicTypeToHref = type => {
  let href;
  switch (type) {
    case "timeline_node":
      href = "timeline-detail";
      break;
    case "post":
      href = "get-involved-detail";
      break;
    case "impact":
      href = "impact-detail";
      break;
    default:
      href = type;
  }
  return href;
};

export { PrismicTypeToHref };
